module.exports = __webpack_public_path__ + "img/int9_esc_pal_01.83aa7fed.jpg";